import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { KaihaiHandyImportColRowModel, KaihaiHandyImportColRowModelDefault } from "@/components/kaihai/KaihaiHandyImportTableModel";
import { PageProps } from "@/assets/pageprops/kaihai";

//Page State
export type KaihaiImportHandySaveState = {
  colWidthsModified: {},
};
export const initialkaihaiState: KaihaiImportHandySaveState = {
  colWidthsModified: {},
};

//Page Slice
export type KaihaiImportHandySaveReducer = {
  initOnDidMount: (state: KaihaiImportHandySaveState, action: PayloadAction<PageProps>) => void,
  resetOnWillUnmount: (state: KaihaiImportHandySaveState) => void,
  columnWidthChange: (state: KaihaiImportHandySaveState, action: PayloadAction<{ colKey: string, width: number }>) => void,
}

const createReducerContent = (name: string, colRowModel: KaihaiHandyImportColRowModel, initialState: KaihaiImportHandySaveState): KaihaiImportHandySaveReducer => {
  return {
    //componentDidMount
    initOnDidMount(state: KaihaiImportHandySaveState, action: PayloadAction<PageProps>) {
      if (state.colWidthsModified === undefined) {
        state.colWidthsModified = initialState.colWidthsModified;
      }
    },
    //componentWillUnmount
    resetOnWillUnmount(state: KaihaiImportHandySaveState) {
    },
    columnWidthChange(state: KaihaiImportHandySaveState, action: PayloadAction<{ colKey: string, width: number }>) {
      console.log('store.columnWidthChange');
      const colKey = action.payload.colKey;
      const width = action.payload.width;
      if (colKey && width) {
        state.colWidthsModified[colKey] = width;
      }
    },
  }
};

const createSliceContent = (name: string, colRowModel: KaihaiHandyImportColRowModel, initialState: KaihaiImportHandySaveState) => createSlice({
  name: name,
  initialState: initialState,
  reducers: createReducerContent(name, colRowModel, initialState),
});

//Page Slice Export
//KaihaiImportHandySaveSlice
export const kaihaiImportHandySaveSlice = createSliceContent("kaihaiImportHandySave", KaihaiHandyImportColRowModelDefault, initialkaihaiState);
